import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';

// eslint-disable-next-line
interface RevealDropdownTriggerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

interface RevealDropdownProps {
  className?: string;
  btnClassName?: string;
  dropdownMenuClassName?: string;
  icon?: IconProp;
}

export const RevealDropdownTrigger: React.FC<RevealDropdownTriggerProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div className={classNames('btn-reveal-trigger', className)} {...rest}>
      {children}
    </div>
  );
};

const RevealDropdown: React.FC<PropsWithChildren<RevealDropdownProps>> = ({
  children,
  className,
  btnClassName,
  dropdownMenuClassName,
  icon = faEllipsisVertical
}) => {
  return (
    <Dropdown className={classNames(className)} align="start" drop="end">
      <Dropdown.Toggle
        variant=""
        size="sm"
        className={classNames(
          btnClassName,
          'btn-reveal dropdown-caret-none transition-none'
        )}
      >
        <FontAwesomeIcon icon={icon} className="fs-10" />
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={classNames(dropdownMenuClassName, 'py-1')}
        popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-10, 4]
              }
            }
          ]
        }}
      >
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RevealDropdown;
